// Daftar subkategori berdasarkan kategori
const SubkategoriMengelolaDiri = [
  {
    category: "Mengelola Diri",
    questions: [
      { label: "Adaptasi terhadap perubahan", name: "1" },
      { label: "Integritas", name: "2" },
      { label: "Komitmen pada pengembangan", name: "3" },
    ],
  },
];

const SubkategoriMengelolaOrangLain = [
  {
    category: "Mengelola Orang Lain",
    questions: [
      { label: "Orientasi pada pelayanan", name: "4" },
      { label: "Kerjasama", name: "5" },
      { label: "Komunikasi", name: "6" },
    ],
  },
];

const SubkategoriMengelolaPekerjaan = [
  {
    category: "Mengelola Pekerjaan",
    questions: [
      { label: "Analisa masalah", name: "7" },
      { label: "Orientasi pada kualitas", name: "8" },
      { label: "Inovasi", name: "9" },
      { label: "Perencanaan", name: "10" },
    ],
  },
];

export const FormSubkategoriIndividu = [
  ...SubkategoriMengelolaDiri,
  ...SubkategoriMengelolaOrangLain,
  ...SubkategoriMengelolaPekerjaan,
];

export const FormSubkategoriKelompok = [
  ...SubkategoriMengelolaOrangLain,
  ...SubkategoriMengelolaPekerjaan,
];
